// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getProductsForProductInfoList } from "@insite/client-framework/Store/Components/ProductInfoList/ProductInfoListSelectors";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import { CustomAppState, ReorderPadApiModal, ReorderPadModal } from "@keller/App/Store/Reducers";
import find from "lodash/find";

export const getReorderPad = (state: ApplicationState) => {
    return (state as CustomAppState).xReorderPad;
};

export function getReorderPadDataViewProperty<K extends keyof Omit<ReorderPadApiModal, "ids">>(
    state: ApplicationState,
    key: K,
) {
    const productsDataView = getReorderPad(state);
    return productsDataView.views ? productsDataView.views[key] : undefined;
}

export const getReorderPadProducts = (state: ApplicationState) => {
    const orders = getReorderPadDataViewProperty(state, "items");
    const products = getProductsForProductInfoList(state, "ReorderPad_Products");

    const newProducts: ProductModel[] | undefined = [];
    orders?.forEach(order => {
        const product = find(products, { productNumber: order.productERPNumber });
        if (!product) {
            return;
        }
        const newProduct = { ...product };
        Object.keys(order).forEach(key => {
            if (key !== "productERPNumber") {
                const value = (order[key as keyof ReorderPadModal] || "") as string;
                newProduct.properties = {
                    ...newProduct.properties,
                    [key]: value || "",
                };
            }
        });
        newProducts.push(newProduct);
    });

    return newProducts || [];
};

export const getReorderPadIsLoading = (state: ApplicationState) => {
    const orders = getReorderPadDataViewProperty(state, "items");
    const products = getProductsForProductInfoList(state, "ReorderPad_Products");
    const isLoading = getReorderPad(state).isLoading;

    if (isLoading) {
        return isLoading;
    }

    return orders && orders?.length > 0 && (!products || products?.length === 0);
};
